import React, { Component } from 'react'
import '@loyal_template/wishlist.css'
import PropTypes from 'prop-types'
import { Checkbox } from 'loyal-react'
import { WishlistHeart } from 'features/WishlistHeart'
import ReactImageFallback from 'react-image-fallback'
import imagefallback from '@loyal_images/products/product_placeholder.png'
import { Link } from 'react-router-dom'

import { CatalogCurrencyLabel } from 'Shared/CurrencyLabel'

class Item extends Component {
  constructor (props) {
    super(props)
    this.state = { checked: true }
  }

  render () {
    var statusCart = ''
    if (this.props.product.loadingAddCart) statusCart = 'Loading no Cart'
    else if (this.props.product.loadingAddCart === false) {
      if (this.props.product.addedCart) {
        statusCart = 'added no Cart'
      } else if (this.props.product.errorAddCart) {
        statusCart = 'error no Cart'
      }
    }
    var styleStatusCart = { fontWeigth: 'bold' }
    return (
      <div className='wishlist-item row px-1 border-color-ui-3 border-bottom py-2'>
        <Link to={`/products/${this.props.product.skuId}`}>
          <div className='wishlist-img col-auto col-md-auto txt-center px-0 pl-md-1 pr-md-2'>
            <ReactImageFallback
              src={this.props.product.mediumImage}
              fallbackImage={imagefallback}
              initialImage={imagefallback}
              alt={this.props.product.productName}
              className='card-image-fallback'
            />
          </div>
        </Link>

        <div className='wishlist-product-info col col-md-7 mr-0 mr-md-auto'>
          <Link to={`/products/${this.props.product.skuId}`}>
            <div className='wishlist-product-info row'>
              <div className='product-infos col-12 mx-0'>
                <h2 className='txt-font-body txt-body-sm color-ui-2'>
                  {this.props.product.productName}{' '}
                  <span style={styleStatusCart}>
                    {' '}
                    {statusCart !== '' ? ` - ${statusCart}` : ''}
                  </span>
                </h2>
              </div>
            </div>
          </Link>

          <div className='row card-price-item mt-1'>
            <div className='wishlist-price-points col-12 txt-title-3 txt-font-body txt-left title-color'>
              { this.props.product.sellingPrice > 0
                ? <CatalogCurrencyLabel value={this.props.product.sellingPrice} />
                : (
                  <strong className={`price-value txt-initial color-error`}>
                    Produto indisponível
                  </strong>
                )
              }
            </div>
          </div>
        </div>
        <div className='col-auto icon-area row mx-0 px-0'>
          <div className='col-12 col-md-auto row mx-0 px-0'>
            <div className='wishlist-action pos-relative col-12 col-md-auto txt-center px-0'>
              <div className='row mx-0 align-items-center h-auto'>
                <WishlistHeart skuId={this.props.product.skuId} />
              </div>
            </div>
          </div>
          <div className='col-12 col-md-auto row mx-0 px-0'>
            <div className='wishlist-action pos-relative col-12 col-md-auto txt-center px-0'>
              <div className='row mx-0 align-items-center h-auto'>
                <Checkbox
                  id={'checkbox_' + this.props.product.skuId}
                  className='col-12'
                  labelClass='l-0'
                  defaultChecked={this.props.product.selected}
                  checked={this.props.product.selected}
                  disabled={this.props.product.removed}
                  onChange={e => {
                    this.props.selectItem(this.props.product, e.target.checked)
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Item.propTypes = {
  product: PropTypes.object,
  selectItem: PropTypes.func
}

export default Item



// WEBPACK FOOTER //
// ./src/Participant/Wishlist/WishlistPage/Item.js